import { render, staticRenderFns } from "./sup-withdraw-vega.vue?vue&type=template&id=548f5510"
import script from "./sup-withdraw-vega.vue?vue&type=script&lang=js"
export * from "./sup-withdraw-vega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports